<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch21"></a><a id="page_22"></a><a href="#/contents#ch21"><b>Why’s It Called That?</b></a></h2>
<p class="noindent"><span>Canned herring are called sardines because the canning process was developed in Sardinia.</span></p>
<p class="noindent"><span>Producer Terry Melcher wrote “(untitled)” as a placeholder for the name of the Byrds’ ninth album. It mistakenly went to press with the title <i>(Untitled)</i>.</span></p>
<p class="noindent"><span>In the 1920s, the nickname “the Big Apple” was popularized by New York newspaper columnist John J. FitzGerald.</span></p>
<p class="noindent"><span>Pink Floyd got its name from two Georgia bluesmen, “Pink” Anderson and Floyd Council.</span></p>
<p class="noindent"><span>The original “quisling” (traitor) was Norwegian fascist Vidkun Quisling, who helped the Nazis invade his own country.</span></p>
<p class="noindent"><span>The word “maverick” came into common use in 1845. It referred to unbranded cattle owned by Texas rancher Samuel Maverick.</span></p>
<p class="noindent"><span>The term “ritzy” comes from the posh European hotels run by Swiss innkeeper César Ritz.</span></p>
<p class="noindent"><span><i>Billboard</i> magazine was founded in 1894 as a trade publication for people who manufactured and used billboards.</span></p>
<p class="noindent"><span>Bingo was originally called “beano” because players used beans to mark their cards.</span></p>
<p class="noindent"><span>In golf, the word “green” once meant the entire course.</span></p>
<p class="noindent"><span>The Pet Shop Boys claim they titled their album <i>Please</i> so people would have to ask for it politely.</span></p>
<p class="noindent"><span>The word “aftermath” was originally “aftermowth,” and it referred to the new growth of grass after mowing.</span></p>
<p class="noindent"><span>“Acid rock,” “country rock,” and “hard rock” were all geological terms before they were musical genres.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter21.vue?481629ab